import { useLayoutEffect } from 'react';
import { useLocation } from 'react-router-dom';

import { alarmInfo } from 'api/haccp/monitoring/commonApi';
import useAlarm from 'global/alarmState';

/**
 * 알람 정보
 */
function useAlarmInfo() {
  /* router */
  const { pathname } = useLocation();

  /* recoil */
  const { setAlarm } = useAlarm();

  /* watch */
  useLayoutEffect(() => {
    requestAlarm();
  }, [pathname]);

  /* method */
  // 알람정보 조회
  const requestAlarm = async () => {
    const { data = [] } = await alarmInfo();
    setAlarm(data);
  };
}

export default useAlarmInfo;
